module.exports = __webpack_public_path__ + "static/media/antigua-accommodation-17.5b402467.jpg";